import { Pipe, PipeTransform } from '@angular/core';
import { RegistrationStudent } from '../../../models/registration-student.model';

@Pipe({
  name: 'selectStudentPipe'
})
export class SelectStudentPipe implements PipeTransform {

  transform(students: RegistrationStudent[], studentId: number): RegistrationStudent[] {
    return students.filter(x => x.Id == studentId);
  }

}
